import { JourneyMapDraft } from '../types/journeyMap';

export type ValidationIssue = {
  field: string;
  message: string;
};

export function validateJourneyMapDraft(draft: JourneyMapDraft): ValidationIssue[] {
  const issues: ValidationIssue[] = [];

  if (!draft.name?.trim()) {
    issues.push({ field: 'name', message: 'Journey map name is required.' });
  }

  if (!draft.journey_type) {
    issues.push({ field: 'journey_type', message: 'Journey type is required.' });
  }

  const activeItems = draft.items.filter((item) => !item.isDeleted);

  if (!activeItems.length) {
    issues.push({ field: 'items', message: 'At least one item is required.' });
  }

  activeItems.forEach((item, idx) => {
    if (!item.name?.trim()) {
      issues.push({ field: `items[${idx}].name`, message: 'Each item requires a name.' });
    }
  });

  return issues;
}